import { get } from "../methods";
import { removeLeadingSlash } from "../utils";
function eventTypeReducer(acc, current) {
  acc[`event_type_ids[${current}]`] = 1;
  return acc;
}
const eventsMapping = {
  dividend: [152, 213, 214, 215, 230, 232, 233, 36, 45, 46, 47, 53, 54, 94].reduce(eventTypeReducer, {}),
  management: [101, 102, 16, 92].reduce(eventTypeReducer, {}),
  strategy: [1, 137, 21, 22, 23, 3, 31, 32, 41, 44, 63, 65, 73, 78, 80, 82].reduce(eventTypeReducer, {}),
  financial: [11, 135, 136, 150, 225, 226, 26, 27, 28, 29, 42, 43, 5, 59, 61, 74, 83, 85, 86, 87, 88, 93].reduce(eventTypeReducer, {}),
  other: [12, 153, 154, 155, 156, 157, 160, 163, 164, 172, 177, 187, 192, 194, 205, 206, 207, 224, 24, 25, 56, 57, 58, 62, 7, 75, 76, 77, 79, 89, 90, 91, 95, 97, 99].reduce(eventTypeReducer, {})
};
function companyDevelopments({ companyId, payload, categories }, headers = {}) {
  const eventsPayload = categories.reduce(
    (acc, current) => {
      if (current in eventsMapping) {
        return {
          ...acc,
          ...eventsMapping[current]
        };
      }
      return acc;
    },
    {}
  );
  return get({
    url: `api/company/developments/${removeLeadingSlash(companyId)}`,
    payload: {
      ...payload,
      ...eventsPayload
    },
    headers
  });
}
export {
  companyDevelopments as default
};
